var exports = {
  "kL": "x127c5a35--5a6547--container",
  "uW": "x127c5a35--5a6547--filters",
  "nM": "x127c5a35--5a6547--row",
  "HX": "x127c5a35--5a6547--favorites-type",
  "Lu": "x127c5a35--5a6547--favorites-type-item",
  "Rf": "x127c5a35--5a6547--favorites-type-item--active",
};

module.exports = exports;
